import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { setShowSearch } from "../../store/appConfigsSlice";

import { SupportAccessVerify } from "../../components/support";

const SupportAccessPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, [dispatch]);

  return <SupportAccessVerify />;
};

export default withTranslation()(SupportAccessPage);
